import type { CSSProperties, FC, ReactNode } from 'react'
import type { ToasterProps } from 'sonner'

import { Toaster as Sonner } from 'sonner'
import { CircleCheck, CircleX, Info, LoaderCircle, TriangleAlert } from 'lucide-react'
import { useTheme } from '@/components/generals/theme-provider'

export const Toaster: FC<ToasterProps> = (props): ReactNode => {
    const { resolvedTheme } = useTheme()

    return (
        <Sonner
            theme={resolvedTheme}
            position='bottom-right'
            closeButton
            className='toaster group'
            icons={{
                success: <CircleCheck className='size-4 text-success' />,
                info: <Info className='size-4 text-info' />,
                warning: <TriangleAlert className='size-4 text-warning' />,
                error: <CircleX className='size-4 text-destructive' />,
                loading: <LoaderCircle className='size-4 animate-spin' />
            }}
            style={{
                '--normal-bg': 'var(--popover)',
                '--normal-text': 'var(--popover-foreground)',
                '--normal-border': 'var(--border)',
                '--border-radius': 'calc(var(--radius) + 2px)'
            } as CSSProperties}
            toastOptions={{
                classNames: {
                    toast: 'font-sans shadow-lg',
                    description: 'text-muted-foreground!'
                }
            }}
            {...props}
        />
    )
}
